import React, { useContext, useState } from 'react';
import { Row, Col, Input, Radio  } from "antd";
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { AppContext } from '../../../util/context';
import '../../../pages/Home/Home.css';
import ActionTakenInput from './ActionTakenInput';
import { v4 as uuidv4 } from 'uuid';

export const ActionDetailsData = ({hazardCard, setHazardCard, isRep}) => {
    const {
        StyledDiv
    } = useContext(AppContext)
    
    const [actionDetails, setActionDetails] = useState("")
    const [actionDetailsValidation, setActionDetailsValidation] = useState("")
    const [maxChar, setMaxChar] = useState("0");

    const handleActionChange = (e, index) => {
        const currentActions = [...hazardCard.actions]; 
        currentActions[index] = { ...currentActions[index], action: e.target.value, update: "edit" }; 
        const newHazardCard = { ...hazardCard, actions: currentActions, updateActionsRequired: true }; 
        setHazardCard(newHazardCard);
    };

    const handleAddAction = () => {
        if(actionDetails === ""){
            setActionDetailsValidation("Action details is required");
        }else{
            const currentActions = [
                ...hazardCard.actions,
                {action: actionDetails, status: "new", update: "add", id: uuidv4()}
            ];
            const newHazardCard = { 
                ...hazardCard, 
                updateActionsRequired: true,
                actions: currentActions 
            }; 
            setHazardCard(newHazardCard);
            setActionDetails("");
        }
    }

    const handleRemoveAction = (index) => {
        const currentActions = hazardCard.actions;
        currentActions.splice(index, 1);
        const newHazardCard = { ...hazardCard, actions: currentActions }; 
        setHazardCard(newHazardCard)
    }

    return (
        <>
            <Row
                style={{
                    marginTop: "15px",
                }}
            >
                <Col
                    span={24}
                >
                    <StyledDiv className="inputTextLabel"><label>Immediate Action Taken</label></StyledDiv>
                    <Radio.Group 
                        disabled={hazardCard.status === 'closed' || hazardCard.status === 'void' ? true : !isRep}
                        onChange={(e) => {
                            setHazardCard({...hazardCard, immediateActionTaken: e.target.value, updateHazardRequired: true});
                        }}
                        value={hazardCard.immediateActionTaken}
                        style={{
                            marginTop: "10px"
                        }}
                    >
                        
                        <StyledDiv>
                            <Radio value="yes" className="inputText">Yes</Radio>
                            <Radio value="no" className="inputText">No</Radio>
                        </StyledDiv>
                    </Radio.Group>
                </Col>
            </Row>

            {hazardCard.immediateActionTaken === 'yes' && <Row
                style={{
                    marginTop: "15px"
                }}
            >
                <Col
                    span={24}
                >
                    <label>     
                        <StyledDiv className="inputTextLabel">
                            <ActionTakenInput
                                hazardCard={hazardCard}
                                setHazardCard={setHazardCard}
                                isRep={isRep}
                            />
                        </StyledDiv>
                    </label>
                </Col>
            </Row>}

            <Row
                style={{
                    marginTop: "15px",
                }}
            >
                <Col
                    span={24}
                >
                    <StyledDiv className="inputTextLabel"><label>Further Action Required</label></StyledDiv>
                    <Radio.Group 
                        disabled={
                            hazardCard.status === 'closed' ||
                            hazardCard.status === 'void' ||
                            !isRep ||
                            (isRep && hazardCard.actions && hazardCard.actions.length > 0)
                        }
                        value={hazardCard.furtherActionRequired}
                        onChange={(e) => {
                            setHazardCard({...hazardCard, furtherActionRequired: e.target.value, updateHazardRequired: true});
                        }}
                        style={{
                            marginTop: "10px"
                        }}
                    >
                        
                        <StyledDiv>
                            <Radio value="yes" className="inputText">Yes</Radio>
                            <Radio value="no" className="inputText">No</Radio>
                        </StyledDiv>
                    </Radio.Group>
                </Col>
            </Row>
            
            {hazardCard.furtherActionRequired === "yes" && <>
            
                <Row
                    style={{
                        marginTop: "20px",
                    }}
                >
                    <Col
                        span={24}
                    >
                        <StyledDiv className="inputTextLabel"><label>Actions</label></StyledDiv>

                    </Col>  
                </Row>

                {(hazardCard.status !== 'closed' && hazardCard.status !== 'void') && isRep && <>
                    <Row
                        className='InputContainer'
                        style={{
                            marginBottom: "20px"
                        }}
                    >
                        <Col
                            span={24}
                        >
                            <StyledDiv className="homeActionHelperText"><label>
                            Enter the action details in the input box below and select the <span style={{color: "rgb(174,32,114)"}}>+</span> icon to add the action to the list. Selecting the <span style={{color: "red"}}>X</span> will remove the action from the list    
                            </label></StyledDiv>

                        </Col>  

                    </Row>

                    <Row
                        className='homeInputContainer'
                        style={{
                            marginBottom: "40px"
                        }}
                    >
                        <Col
                            span={20}
                        >
                            <StyledDiv>
                                <div className="homeInfoContainer">
                                    <Input.TextArea
                                        placeholder="Enter action (max length 300 characters)"
                                        value = {actionDetails}
                                        style={{
                                            resize: "none",
                                            height: "100px",
                                            marginTop: "8px",
                                            paddingBottom: "5px",
                                            paddingTop: "5px"
                                        }}
                                        onChange={(e) => {
                                            setActionDetails(e.target.value);
                                            setMaxChar(e.target.value.length);
                                            if(actionDetailsValidation !== "") 
                                                setActionDetailsValidation("");
                                        }}
                                        maxLength={300}
                                        className={actionDetailsValidation !== "" ? "homeNewActionInput homeValidationInputText" : "homeNewActionInput"}
                                    />
                                    {actionDetailsValidation !== "" &&
                                        <span className="homeValidationMessage">{actionDetailsValidation}</span>
                                    }
                                    <span className="homeMaxCharMessage">{maxChar}/300</span>
                                </div>
                            </StyledDiv>
                        </Col>  

                        <Col
                            span={4}
                            style={{
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >

                            <PlusOutlined 
                                className="helpIcon"
                                onClick = {() => handleAddAction()}
                            />
                            
                        </Col> 

                    </Row>
                </>}

                {hazardCard.actions && hazardCard.actions.map((action, index) => {
                    return(
                        <Row className='homeActionListContainer'
                            key={action.id + index}
                        >
                            <Col 
                                xl={{span: 19}}
                                lg={{span: 19}}
                                md={{span: 19}}
                                sm={{span: 19}}
                                xs={{span: 19}} 
                                className="actionListText"
                            >
                                <StyledDiv>
                                    <Input.TextArea
                                        disabled={!isRep || (isRep && action.status !== 'open' && action.status !== 'new')}
                                        onChange={(e) => handleActionChange(e, index)}
                                        className="homeActionInput"
                                        defaultValue={action.action}
                                        autoSize={{ minRows: 1, maxRows: 4 }}
                                    />
                                </StyledDiv>
                            </Col>

                            <Col
                                xl={{span: 4}}
                                lg={{span: 4}}
                                md={{span: 4}}
                                sm={{span: 4}}
                                xs={{span: 4}}
                                className="actionListText"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <div
                                    className={action.status === 'open' || action.status === 'new' || action.status === 'assigned' || action.status === 'reassigned' ?
                                        "statusContainer openStatus" : action.status === 'closed' ?
                                                "statusContainer closedStatus" : action.status === 'void' ?
                                                    "statusContainer voidStatus" : action.status === 'completed' ?
                                                        "statusContainer completedStatus" : "statusContainer"
                                    }
                                >
                                    <StyledDiv ><label>{action.status.toUpperCase()}</label></StyledDiv>
                                </div>
                                
                            </Col>

                            <Col
                                xl={{span: 1}}
                                lg={{span: 1}}
                                md={{span: 1}}
                                sm={{span: 1}}
                                xs={{span: 1}}
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    alignItems: "center",
                                }}
                            >
                                {action.status === 'new' && <CloseOutlined className="homeRemoveActionIcon" onClick = {() => handleRemoveAction(index)} />}
                            </Col>
                        </Row>
                    )
                })}
            </>}
        </>
    )
}
